import { Parser } from '~/api';
import { Server } from '~/api/models/Server';
import RequestService from './request';

interface UpdateData {
    beta: boolean;
}

export interface Version {
    name: string;
    edition_version: string;
    minecraft_version: string;
    stable: boolean;
}

export interface Edition {
    id: string;
    name: string;
    versions: Version[];
}

export interface MinecraftData {
    editions: Record<string, Edition>;
}

interface InstallEditionData {
    edition: string;
    version: string;
    format: boolean;
}

interface InstallFiveMVersionData {
    version: string;
}

interface ReinstallServerData {
    wipe_all_files: boolean;
    backup_before_reinstall: boolean;
    start_on_completion: boolean;
}

class AdvancedService {
    toggleSupport() {
        return RequestService.post('/servers/:server/advanced/support').then(Parser.parse).then(RequestService.updateModelBinding);
    }

    toggleMonitor(): Promise<Server> {
        return RequestService.post('/servers/:server/advanced/monitor').then(Parser.parse).then(RequestService.updateModelBinding);
    }

    // TODO: the following actions should also update server state?
    update(data: UpdateData): Promise<Server> {
        return RequestService.post('/servers/:server/advanced/update', data);
    }

    fetchVersions(): Promise<MinecraftData> {
        return RequestService.get('/servers/:server/advanced/versions');
    }

    installVersion(data: InstallEditionData): Promise<void> {
        return RequestService.post('/servers/:server/advanced/version', {
            ...data,
            edition: data.edition.split('_snapshots')[0],
        });
    }

    reinstall(data: ReinstallServerData): Promise<void> {
        return RequestService.post('/servers/:server/advanced/reinstall', data);
    }

    fetchFiveMVersions(): Promise<any> {
        return RequestService.get('/servers/:server/advanced/fivem-versions');
    }

    installFiveMVersion(data: InstallFiveMVersionData): Promise<void> {
        return RequestService.post('/servers/:server/advanced/fivem-version', data);
    }

    reindexEditions(): Promise<void> {
        return RequestService.post('/servers/:server/advanced/versions/reindex');
    }
}

export default new AdvancedService();
